import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FabButton from '../FabButton';
import styles from './styles';
import classNames from 'classnames';

class SingleActionButtonPanel extends React.Component {

    render() {
        const { classes, Icon } = this.props;
        const hasIcon = Boolean(Icon);

        return (
            <div className={classNames(classes.panelBottom)}>
                <FabButton
                    onClick={this.props.actionClicked}>
                    {hasIcon && <Icon />}
                    <span style={{ marginLeft: 8 }}>
                        {this.props.actionText}
                    </span>
                </FabButton>
            </div>
        );
    }
}

SingleActionButtonPanel.propTypes = {
    actionText: PropTypes.string.isRequired,
    actionClicked: PropTypes.func.isRequired,
    Icon: PropTypes.func
};

export default withStyles(styles)(SingleActionButtonPanel);